<template>
  <div class="content_box">
    <div class="userManage" id="ManageTable">
      <div class="userManage_header">
        <div class="userManage_logo">
          <img src="@/assets/imgs/icon/user_logo.png" alt />
        </div>
        <h3>地图配置</h3>
      </div>
      <!-- <div class="userManage_form"> -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="地图类型">
          <el-select
            v-model="formInline.type"
            placeholder="请选择"
            @change="changeMap"
          >
            <el-option label="请选择" value></el-option>
            <el-option label="区域地图" value="areaMap"></el-option>
            <el-option label="园区地图" value="gardenMap"></el-option>
            <el-option label="项目地图" value="projectMap"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="初始地图倍数" style="margin-left: 40px">
          <el-input
            v-model.trim="formInline.baseNum"
            placeholder="请输入初始地图倍数"
          ></el-input>
        </el-form-item>
        <el-form-item label="放大地图倍数" style="margin-left: 40px">
          <el-input
            v-model.trim="formInline.bigNum"
            placeholder="请输入放大地图倍数"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 40px">
          <el-button
            type="primary"
            @click="onSubmit"
            class="bg5584FF formBotton"
            >提交</el-button
          >
          <el-button type="info" @click="reset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <hr />
      <div class="effectiveBox" style="padding-bottom: 160px">
        <h3>地图json文件上传</h3>
        <!-- <el-upload
        style="float: left"
        action
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :on-change="onChange"
        :multiple="true"
        :limit="50"
        :auto-upload="false"
        :on-exceed="handleExceed"
        :file-list="fileList"
      >
        <el-button type="primary" icon="el-icon-upload" style="margin-left: 40px;">上传</el-button>
      </el-upload>-->
        <el-upload
          drag
          style="float: left"
          action
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :on-change="onChange"
          :multiple="true"
          :limit="50"
          :auto-upload="false"
          :on-exceed="handleExceed"
          :file-list="fileList"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
        </el-upload>
      </div>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      formInline: {
        //查询对象
        type: "",
        baseNum: "",
        bigNum: "",
        fileList: [],
      },
    };
  },
  created() {
    // this.getdata(this.pageNum);
  },
  methods: {
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleExceed() {
      this.$message.warning(`当前限制选择 50 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    onChange(file, fileList) {
      const self = this;
      self.fileList = fileList;
      console.log(fileList);
      self.loading = true;
      const formdata = new FormData();
      let newfileList = [];
      for (let i = 0; i < fileList.length; i++) {
        // newfileList[newfileList.length] = fileList[i].raw;
        formdata.append("files", this.fileList[i].raw);
      }

      // console.log(newfileList);
      // formdata.append("files", newfileList);
      // formdata.append("files", this.fileList[0].raw);

      console.log(formdata);

      // type:1追加 2 覆盖
      // formdata.append("type", 1);
      self.$axios
        .post("/business/mapSite/uploadMapJsonBatch", formdata)
        .then((res) => {
          console.log(res);
          self.fileList = [];
          self.$message.success("json数据上传成功");
          self.loading = false;
        })
        .catch((err) => {
          self.loading = false;
          console.log("error", err);
        });
    },
    updata(obj) {
      this.loading = true;
      this.$axios
        .post("/business/mapSite/updateByType", obj)
        .then((res) => {
          Message.success("提交成功");
        })
        .catch((error) => {
          Message.success("提交失败");
          console.log(error);
        });
    },
    getdata(type) {
      this.$axios
        .get("/business/mapSite/selectByType?type=" + type)
        .then((res) => {
          this.formInline = res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeMap(e) {
      if (e) {
        this.getdata(e);
      } else {
        for (const key in this.formInline) {
          this.formInline[key] = "";
        }
      }
    },

    onSubmit() {
      //查询
      console.log(this.formInline);
      this.updata(this.formInline);
    },
    reset() {
      //重置
      for (const key in this.formInline) {
        this.formInline[key] = "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
.userManage {
  box-shadow: 0px 0px 50px #ccc;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  .userManage_header {
    height: 31px;
    width: 100%;
    display: flex;
    margin-bottom: 30px;
    .userManage_logo {
      margin: 2px 20px 0 2px;
    }
    h3 {
      font-size: 24px;
      height: 100%;
      margin: 0;
      color: #444444;
    }
  }
  .userManage_form {
    height: 70px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(155, 155, 155, 0.25);
    margin-bottom: 20px;
    .el-form {
      .el-form-item {
        margin-right: 30px;
      }
    }
  }
  .userManage_add_user {
    margin-bottom: 20px;
  }
  .el-dialog {
    .addUser {
      .el-form-item {
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}

.effectiveBox {
  margin: 40px 0;
  h3 {
    margin: 20px 0;
  }
}
</style>